import { Content } from "@carbon/react";
import { useListChannels } from "api/channels/listChannels";
import { withAuth } from "components/withAuth";
import React, { Suspense, lazy } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import TrialBar from "components/TrialBar";
import styles from "./layoutRegistered.module.scss";
import GenericSkeleton from "components/GenericSkeleton";

const Sidebar = lazy(() => import("components/Sidebar"));
const Header = lazy(() => import("components/Header"));

function LayoutRegistered() {
  const location = useLocation();
  const dispatch = useDispatch();
  const channel = useSelector((state) => state.selectedChannel);
  const sidebarLocked = useSelector(
    (state) => state.sidebarLocked,
    shallowEqual
  );

  const { isLoading } = useListChannels();

  const toggle = React.useCallback(() => {
    dispatch({
      type: "SIDEBAR_TOGGLE",
      payload: !sidebarLocked,
    });
  }, [sidebarLocked, dispatch]);

  return (
    <>
      <Suspense fallback={null}>
        <Header expanded={sidebarLocked} setExpanded={toggle} />
        <Sidebar expanded={sidebarLocked} setExpanded={toggle} />
      </Suspense>

      <TrialBar />

      <Content
        className={
          styles.content + (sidebarLocked ? " " + styles.contentLock : "")
        }
      >
        <React.Suspense fallback={<GenericSkeleton />}>
          {!channel.status && isLoading ? (
            <GenericSkeleton />
          ) : channel.status === "ok" ||
            channel.status === "awaiting_payment" ||
            channel.status === "trial" ||
            location.pathname.includes("/profile/") ? (
            <Outlet />
          ) : (
            <Navigate replace to={"/profile/plans"} />
          )}
        </React.Suspense>
      </Content>
    </>
  );
}

export default withAuth(LayoutRegistered);
